<app-modal-container class="no-modal-margin">
  <div class="modal-header-content">
    {{ 'change_role' | translate }}
  </div>
  <div class="modal-body-content">
    <div class="text-black">{{ 'change_academy_roles_dual_role_description' | translate }}</div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="setRoleForm">
      <app-common-checkbox-select
        [form]="form"
        [values]="[$roles.manager, $roles.learner]"
        [context]="{
          label: changeRolesDescription,
          field: 'roles',
          nameKey: mapRoleValueToNameKey,
          translateName: true,
        }"
      ></app-common-checkbox-select>
    </form>
  </div>
  <div class="modal-footer-content">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button id="modalCancel" class="btn btn-outline-primary" (click)="container.closeModal()">
          {{ 'form_cancel' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button id="modalAction" class="btn btn-primary" type="submit" [disabled]="form.invalid" form="setRoleForm">
          {{ 'form_change' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
